import React from 'react';

export default {
	path: '/vesshare-regulations',
	components: () => [import('./component')],
	render: ([Regulation]) => <Regulation />,
};
